
import ConfigScene from '../../../helpers/ConfigScene';
import ItemBullet from './ItemBullet';

class BulletLayer extends PIXI.Container {
  constructor(layerId) {
    super();

    // vars
    this.layerId = layerId;

    // move
    this.diff = [0, 0];

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // vars
    this.diff = ConfigScene.MOVE_DIFF_BULLETS[this.layerId];

    // bullets
    this.setBullets();

    // add loop
    aScene.signals.loopCall.add(this.loopUp, this);
  }

  // --------------------------------------------------------------
  // Bullets
  // --------------------------------------------------------------

  setBullets() {
    // get data
    const imsData = aScene.dataPool.town[`lr-${this.layerId}`];

    // set bullets
    for (let i = 0; i < imsData.length; i += 1) {
      if (this.mikulasCheck(imsData[i].id)) {
        this.addChild(new ItemBullet(imsData[i]));
      }
    }
  }

  mikulasCheck(itemId) {
    return (aPage.mikulas && itemId.indexOf('nomik') === -1) ||
      (!aPage.mikulas && itemId.indexOf('mikulas') === -1);
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    if (aScene.sceneManager.sceneState !== 1) {
      this.x = this.diff[0] * aScene.iManager.stageRatio.half.x;
      this.y = this.diff[1] * aScene.iManager.stageRatio.half.y;
    }
  }
}

export default BulletLayer;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/BulletLayer.js